import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";

var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { decodePickingColor, DOM } from '@antv/l7-utils';
import { inject, injectable } from 'inversify';
import 'reflect-metadata';
import { TYPES } from '../../types';
import { isEventCrash } from '../../utils/dom';
import { InteractionEvent } from '../interaction/IInteractionService';
import { gl } from '../renderer/gl';
var PickingService = (_dec = injectable(), _dec2 = inject(TYPES.IRendererService), _dec3 = inject(TYPES.IGlobalConfigService), _dec4 = inject(TYPES.IInteractionService), _dec5 = inject(TYPES.ILayerService), _dec(_class = (_class2 = function () {
  function PickingService() {
    var _this = this;

    _classCallCheck(this, PickingService);

    _initializerDefineProperty(this, "rendererService", _descriptor, this);

    _initializerDefineProperty(this, "configService", _descriptor2, this);

    _initializerDefineProperty(this, "interactionService", _descriptor3, this);

    _initializerDefineProperty(this, "layerService", _descriptor4, this);

    _defineProperty(this, "pickingFBO", void 0);

    _defineProperty(this, "width", 0);

    _defineProperty(this, "height", 0);

    _defineProperty(this, "alreadyInPicking", false);

    _defineProperty(this, "pickBufferScale", 1.0);

    _defineProperty(this, "lastPickTime", new Date().getTime());

    _defineProperty(this, "pickFromPickingFBO", function (layer, _ref) {
      var _pickedColors;

      var x = _ref.x,
          y = _ref.y,
          lngLat = _ref.lngLat,
          type = _ref.type,
          target = _ref.target;
      var isPicked = false;
      var _this$rendererService = _this.rendererService,
          getViewportSize = _this$rendererService.getViewportSize,
          readPixels = _this$rendererService.readPixels,
          getContainer = _this$rendererService.getContainer;

      var _this$getContainerSiz = _this.getContainerSize(getContainer()),
          width = _this$getContainerSiz.width,
          height = _this$getContainerSiz.height;

      width *= DOM.DPR;
      height *= DOM.DPR;

      var _layer$getLayerConfig = layer.getLayerConfig(),
          enableHighlight = _layer$getLayerConfig.enableHighlight,
          enableSelect = _layer$getLayerConfig.enableSelect;

      var xInDevicePixel = x * DOM.DPR;
      var yInDevicePixel = y * DOM.DPR;

      if (xInDevicePixel > width - 1 * DOM.DPR || xInDevicePixel < 0 || yInDevicePixel > height - 1 * DOM.DPR || yInDevicePixel < 0) {
        return false;
      }

      var pickedColors;
      pickedColors = readPixels({
        x: Math.floor(xInDevicePixel / _this.pickBufferScale),
        y: Math.floor((height - (y + 1) * DOM.DPR) / _this.pickBufferScale),
        width: 1,
        height: 1,
        data: new Uint8Array(1 * 1 * 4),
        framebuffer: _this.pickingFBO
      });

      if (pickedColors[0] !== 0 || pickedColors[1] !== 0 || pickedColors[2] !== 0) {
        var pickedFeatureIdx = decodePickingColor(pickedColors);
        var rawFeature = layer.getSource().getFeatureById(pickedFeatureIdx);

        if (pickedFeatureIdx !== layer.getCurrentPickId() && type === 'mousemove') {
          type = 'mouseenter';
        }

        var layerTarget = {
          x: x,
          y: y,
          type: type,
          lngLat: lngLat,
          featureId: pickedFeatureIdx,
          feature: rawFeature,
          target: target
        };

        if (!rawFeature) {} else {
          isPicked = true;
          layer.setCurrentPickId(pickedFeatureIdx);

          _this.triggerHoverOnLayer(layer, layerTarget);
        }
      } else {
        var _layerTarget = {
          x: x,
          y: y,
          lngLat: lngLat,
          type: layer.getCurrentPickId() !== null && type === 'mousemove' ? 'mouseout' : 'un' + type,
          featureId: null,
          target: target,
          feature: null
        };

        _this.triggerHoverOnLayer(layer, _objectSpread(_objectSpread({}, _layerTarget), {}, {
          type: 'unpick'
        }));

        _this.triggerHoverOnLayer(layer, _layerTarget);

        layer.setCurrentPickId(null);
      }

      if (enableHighlight) {
        _this.highlightPickedFeature(layer, pickedColors);
      }

      if (enableSelect && type === 'click' && ((_pickedColors = pickedColors) === null || _pickedColors === void 0 ? void 0 : _pickedColors.toString()) !== [0, 0, 0, 0].toString()) {
        var selectedId = decodePickingColor(pickedColors);

        if (layer.getCurrentSelectedId() === null || selectedId !== layer.getCurrentSelectedId()) {
          _this.selectFeature(layer, pickedColors);

          layer.setCurrentSelectedId(selectedId);
        } else {
          _this.selectFeature(layer, new Uint8Array([0, 0, 0, 0]));

          layer.setCurrentSelectedId(null);
        }
      }

      return isPicked;
    });
  }

  _createClass(PickingService, [{
    key: "init",
    value: function init(id) {
      var _this$rendererService2 = this.rendererService,
          createTexture2D = _this$rendererService2.createTexture2D,
          createFramebuffer = _this$rendererService2.createFramebuffer,
          getViewportSize = _this$rendererService2.getViewportSize,
          getContainer = _this$rendererService2.getContainer;

      var _this$getContainerSiz2 = this.getContainerSize(getContainer()),
          width = _this$getContainerSiz2.width,
          height = _this$getContainerSiz2.height;

      width *= DOM.DPR;
      height *= DOM.DPR;
      this.pickBufferScale = this.configService.getSceneConfig(id).pickBufferScale || 1;
      this.pickingFBO = createFramebuffer({
        color: createTexture2D({
          width: Math.round(width / this.pickBufferScale),
          height: Math.round(height / this.pickBufferScale),
          wrapS: gl.CLAMP_TO_EDGE,
          wrapT: gl.CLAMP_TO_EDGE
        })
      });
      this.interactionService.on(InteractionEvent.Hover, this.pickingAllLayer.bind(this));
    }
  }, {
    key: "boxPickLayer",
    value: function () {
      var _boxPickLayer = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(layer, box, cb) {
        var _this2 = this;

        var _this$rendererService3, useFramebuffer, clear, getContainer;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$rendererService3 = this.rendererService, useFramebuffer = _this$rendererService3.useFramebuffer, clear = _this$rendererService3.clear, getContainer = _this$rendererService3.getContainer;
                this.resizePickingFBO();
                useFramebuffer(this.pickingFBO, function () {
                  clear({
                    framebuffer: _this2.pickingFBO,
                    color: [0, 0, 0, 0],
                    stencil: 0,
                    depth: 1
                  });
                  layer.hooks.beforePickingEncode.call();
                  layer.renderModels();
                  layer.hooks.afterPickingEncode.call();

                  var features = _this2.pickBox(layer, box);

                  cb(features);
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function boxPickLayer(_x, _x2, _x3) {
        return _boxPickLayer.apply(this, arguments);
      }

      return boxPickLayer;
    }()
  }, {
    key: "pickBox",
    value: function pickBox(layer, box) {
      var _this3 = this;

      var _box$map = box.map(function (v) {
        var tmpV = v < 0 ? 0 : v;
        return Math.floor(tmpV * DOM.DPR / _this3.pickBufferScale);
      }),
          _box$map2 = _slicedToArray(_box$map, 4),
          xMin = _box$map2[0],
          yMin = _box$map2[1],
          xMax = _box$map2[2],
          yMax = _box$map2[3];

      var _this$rendererService4 = this.rendererService,
          getViewportSize = _this$rendererService4.getViewportSize,
          readPixels = _this$rendererService4.readPixels,
          getContainer = _this$rendererService4.getContainer;

      var _this$getContainerSiz3 = this.getContainerSize(getContainer()),
          width = _this$getContainerSiz3.width,
          height = _this$getContainerSiz3.height;

      width *= DOM.DPR;
      height *= DOM.DPR;

      if (xMin > (width - 1) * DOM.DPR / this.pickBufferScale || xMax < 0 || yMin > (height - 1) * DOM.DPR / this.pickBufferScale || yMax < 0) {
        return [];
      }

      var pickedColors;
      var w = Math.min(width / this.pickBufferScale, xMax) - xMin;
      var h = Math.min(height / this.pickBufferScale, yMax) - yMin;
      pickedColors = readPixels({
        x: xMin,
        y: Math.floor(height / this.pickBufferScale - (yMax + 1)),
        width: w,
        height: h,
        data: new Uint8Array(w * h * 4),
        framebuffer: this.pickingFBO
      });
      var features = [];
      var featuresIdMap = {};

      for (var i = 0; i < pickedColors.length / 4; i = i + 1) {
        var color = pickedColors.slice(i * 4, i * 4 + 4);
        var pickedFeatureIdx = decodePickingColor(color);

        if (pickedFeatureIdx !== -1 && !featuresIdMap[pickedFeatureIdx]) {
          var rawFeature = layer.getSource().getFeatureById(pickedFeatureIdx);
          features.push(rawFeature);
          featuresIdMap[pickedFeatureIdx] = true;
        }
      }

      return features;
    }
  }, {
    key: "getContainerSize",
    value: function getContainerSize(container) {
      if (!!container.getContext) {
        return {
          width: container.width / DOM.DPR,
          height: container.height / DOM.DPR
        };
      } else {
        return container.getBoundingClientRect();
      }
    }
  }, {
    key: "pickingAllLayer",
    value: function () {
      var _pickingAllLayer = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(target) {
        var t;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.alreadyInPicking || this.layerService.alreadyInRendering || this.layerService.isMapDragging() || !this.layerService.getShaderPickStat())) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                this.alreadyInPicking = true;
                t = new Date().getTime();

                if (!(t - this.lastPickTime > 10 || target.type === 'contextmenu')) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 7;
                return this.pickingLayers(target);

              case 7:
                this.lastPickTime = t;
                this.layerService.renderLayers();
                this.alreadyInPicking = false;

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function pickingAllLayer(_x4) {
        return _pickingAllLayer.apply(this, arguments);
      }

      return pickingAllLayer;
    }()
  }, {
    key: "resizePickingFBO",
    value: function resizePickingFBO() {
      var getContainer = this.rendererService.getContainer;

      var _this$getContainerSiz4 = this.getContainerSize(getContainer()),
          width = _this$getContainerSiz4.width,
          height = _this$getContainerSiz4.height;

      width *= DOM.DPR;
      height *= DOM.DPR;

      if (this.width !== width || this.height !== height) {
        this.pickingFBO.resize({
          width: Math.round(width / this.pickBufferScale),
          height: Math.round(height / this.pickBufferScale)
        });
        this.width = width;
        this.height = height;
      }
    }
  }, {
    key: "pickingLayers",
    value: function () {
      var _pickingLayers = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(target) {
        var _this4 = this;

        var _this$rendererService5, getViewportSize, useFramebuffer, clear, getContainer;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$rendererService5 = this.rendererService, getViewportSize = _this$rendererService5.getViewportSize, useFramebuffer = _this$rendererService5.useFramebuffer, clear = _this$rendererService5.clear, getContainer = _this$rendererService5.getContainer;
                this.resizePickingFBO();
                useFramebuffer(this.pickingFBO, function () {
                  var layers = _this4.layerService.getRenderList();

                  layers.filter(function (layer) {
                    return layer.needPick(target.type);
                  }).reverse().some(function (layer) {
                    clear({
                      framebuffer: _this4.pickingFBO,
                      color: [0, 0, 0, 0],
                      stencil: 0,
                      depth: 1
                    });
                    layer.hooks.beforePickingEncode.call();
                    layer.renderModels(true);
                    layer.hooks.afterPickingEncode.call();

                    var isPicked = _this4.pickFromPickingFBO(layer, target);

                    return isPicked && !layer.getLayerConfig().enablePropagation;
                  });
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function pickingLayers(_x5) {
        return _pickingLayers.apply(this, arguments);
      }

      return pickingLayers;
    }()
  }, {
    key: "triggerHoverOnLayer",
    value: function triggerHoverOnLayer(layer, target) {
      if (isEventCrash(target)) {
        layer.emit(target.type, target);
      }
    }
  }, {
    key: "highlightPickedFeature",
    value: function highlightPickedFeature(layer, pickedColors) {
      var _pickedColors2 = _slicedToArray(pickedColors, 3),
          r = _pickedColors2[0],
          g = _pickedColors2[1],
          b = _pickedColors2[2];

      layer.hooks.beforeHighlight.call([r, g, b]);
    }
  }, {
    key: "selectFeature",
    value: function selectFeature(layer, pickedColors) {
      var _pickedColors3 = _slicedToArray(pickedColors, 3),
          r = _pickedColors3[0],
          g = _pickedColors3[1],
          b = _pickedColors3[2];

      layer.hooks.beforeSelect.call([r, g, b]);
    }
  }]);

  return PickingService;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "rendererService", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "configService", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "interactionService", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "layerService", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
export { PickingService as default };
//# sourceMappingURL=PickingService.js.map